import React, { useState, useEffect } from "react";
import Modal from "../../components/Modal";
import styles from "./MatchTheSentences.module.css";
import { SortableContainer, SortableElement } from "react-sortable-hoc";
import arrayMove from "array-move";
import {
  getMetrics,
  createMetrics,
  updateMetrics,
} from "../../service/service";
import LessonInstruction from "../../containers/instruction/LessonInstruction";
import { useAppGlobalConfig } from "../../providers/AppGlobalConfigContext";

const MatchSentences = ({
  blockData,
  contentIndex,
  step,
  lessonId,
  totalIndexes,
  blockIndex,
  audioUrl,
}) => {
  const [items1, setItems1] = useState([]);
  const [itemsRamdom1, setItemsRandom1] = useState([]);
  const [checked1, setChecked1] = useState(false);
  const [buttonMsg, setButtonMsg] = useState("Check");
  const [solved1, setSolved1] = useState(false);
  const [metrics, setMetrics] = useState(null);
  const [initTime, setInitTime] = useState(Date.now());
  const [totalAttemptsSum, setTotalAttemptsSum] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [btnModalText, setBtnModalText] = useState("Tentar novamente");
  const [modalErrorMsg, setModalErrorMsg] = useState(
    "Erro ao registrar seu progresso. Clique no botão abaixo para tentar novamente"
  );
  const [initialItems1, setInitialItems1] = useState([]);
  const {isEmbedMode} = useAppGlobalConfig();
  let tenant = isEmbedMode ? 'cupheadless' : 'cupfranchise'

  // Coluna 1
  const SortableItem1 = SortableElement(({ value1 }) => {
    // Determina a classe de fundo com base no valor de value1.right1
    const backgroundClass =
      typeof value1.right1 === "undefined"
        ? styles["column-item-default"]
        : value1.right1
        ? styles["column-item-right"]
        : styles["column-item-wrong"];
    return (
      <>
        <div
          className={`${styles["match-sentences-right-column-item"]} ${backgroundClass}`}
        >
          {value1.en.split("/")[0]}
        </div>
      </>
    );
  });

  const SortableList1 = SortableContainer(({ items1 }) => {
    return (
      <ul
        className={styles["match-sentences-column"]}
        style={{ paddingLeft: 0 }}
      >
        {items1.map((value1, index) => (
          <SortableItem1
            key={`item-${value1.id}`}
            index={index}
            value1={value1}
          />
        ))}
      </ul>
    );
  });

  const closeModal = () => {
    setIsModalOpen(false);
    step("skipForward", true);
  };

  const buttonModalAction = async () => {
    setIsLoading(true);
    setBtnModalText("Enviando...");
    try {
      await registerMetrics();
      setIsModalOpen(false);
      step("skipForward", true);
    } catch (error) {
      setModalErrorMsg(
        "O erro ainda continua.. Tente novamente ou clique no botão de fechar para avançar para a próxima lição"
      );
      setIsModalOpen(true);
    }
    setIsLoading(false);
    setBtnModalText("Tentar novamente");
  };

  const registerMetrics = async () => {
    const userInfo = JSON.parse(localStorage.getItem("user-info"));
    const params = {
      userId: userInfo.id,
      blockId: blockData.block_id,
      template: "match_the_sentences",
      bookName: blockData.book_name,
      lessonId: lessonId,
      scores: [
        {
          isRight: true,
          accuracy: 100,
          elapsedTime: Date.now() - initTime,
          dateTime: new Date(initTime).toISOString(),
          totalAttempts: 1,
        },
      ],
      sectionId: blockData.sectionId,
      section: blockData.section,
      index: blockData.num,
      totalIndexes: totalIndexes,
    };

    if (metrics) {
      await updateMetrics(params, tenant);
    } else {
      await createMetrics(params, tenant);
    }
  };

  const getItems1 = () => {
    let items = [];

    items = blockData.complement.respostas
      .filter((a) => a.type !== "instruction")
      .map((item, index1) => {
        item.order1 = index1;
        item.right1 = undefined;
        return item;
      });

    setItems1(items);
    setItemsRandom1(shuffle(items));
    setInitialItems1(items);
  };

  const onSortEnd1 = ({ oldIndex, newIndex }) => {
    setItems1((prevItems1) => arrayMove(prevItems1, oldIndex, newIndex));
  };

  const shuffle = (a) => {
    for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
  };

  const checkOrder = async () => {
    if (buttonMsg === "Done") {
      try {
        // await registerMetrics();
        step("skipForward");
      } catch (error) {
        setIsModalOpen(true);
      }
    }

    if (solved1) return;

    if (checked1) {
      solve();
      return;
    }

    let items1Copy = [...items1];
    for (let i = 0; i < items1.length; i++) {
      if (items1[i].order1 !== i) {
        items1Copy[i].right1 = false;
      } else {
        items1Copy[i].right1 = true;
      }
    }

    setChecked1(true);
    setButtonMsg("Solve");
    setItems1(items1Copy);
  };

  const solve = () => {
    let initialItems1Copy = [...initialItems1];
    initialItems1Copy.forEach((item) => {
      item.right1 = true;
    });

    initialItems1Copy.sort((a, b) => a.order1 - b.order1);

    setItems1(initialItems1Copy);
    setSolved1(true);
    setButtonMsg("Done");
  };

  const resetState = () => {
    setChecked1(false);
    setButtonMsg("Check");
    setSolved1(false);
    getItems1();
  };

  const getMetricsData = async () => {
    const userInfo = JSON.parse(localStorage.getItem("user-info"));
    try {
      const resp = await getMetrics(userInfo.id, blockData.block_id, tenant);
      if (resp.data) {
        setMetrics(resp.data);
        setTotalAttemptsSum(
          resp.data.scores.reduce(
            (accumulator, currentValue) =>
              accumulator + currentValue.totalAttempts,
            0
          )
        );
      } else {
        setTotalAttemptsSum(0);
      }
    } catch (error) {
      setTotalAttemptsSum(0);
      setMetrics(null);
      console.error("Erro ao buscar métricas:", error);
    }
  };

  useEffect(() => {
    getMetricsData();
    resetState();
  }, [blockIndex]);

  return (
    <>
      <div>
        {blockData.content[contentIndex].type === "instruction" ? (
          <>
            <LessonInstruction
              instructionText={blockData.content[contentIndex].instruction}
              audioUrl={audioUrl}
            />
          </>
        ) : (
          <>
            <div>
              <div className={styles["match-sentences-header"]}>
                <h4>Make the correct Matching</h4>
              </div>
              <Modal
                isOpen={isModalOpen}
                onClose={closeModal}
                isLoading={isLoading}
                onActionButtonClick={buttonModalAction}
                message={modalErrorMsg}
                actionButtonText={btnModalText}
              />
              <div className={styles["match-sentences-content"]}>
                <div className={`${styles["match-sentences-column"]}`}>
                  {blockData.content.map((item) =>
                    item.type !== "instruction" ? (
                      <div
                        className={styles["match-sentences-left-column-item"]}
                        key={item.id}
                      >
                        {item.en}
                      </div>
                    ) : null
                  )}
                </div>
                <div>
                  <SortableList1 items1={items1} onSortEnd={onSortEnd1} />
                </div>
              </div>
              {totalAttemptsSum !== null &&
                console.log(`Total attempts: ${totalAttemptsSum}`)}
            </div>
            <div className={styles["match-sentences-content-footer"]}>
              <button
                className={styles["match-sentences-check-button"]}
                onClick={checkOrder}
              >
                {buttonMsg}
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default MatchSentences;
